<template>
  <Adminlte>
      <div class="box box-primary center-block">
        <div class="box-header with-border">
          <i class="fa fa-table font-dark"></i>
          <h3 class="box-title">Exportação de dados - Parques</h3>
        </div>

        <section class="content">
          <div class="row main-row">
            <div class="col-md-offset-2 col-md-8 col-lg-offset-3 col-lg-6">
              <div class="inner-box">
                <ParksFilter :parks="parks" :disabled="waitingDownload" />
              </div>

              <button
                class="btn btn-block btn-success"
                @click="handleDownloadClick"
                :disabled="waitingDownload || selectedParksIds.length === 0"
              >
                Baixar parques selecionados (Excel) &nbsp;
                <i class="fa fa-refresh fa-spin" v-if="waitingDownload"></i>
              </button>

              <button
                class="btn btn-block btn-primary confirmed-export-btn"
                @click="handleConfirmedDownloadClick"
                :disabled="waitingConfirmedDownload"
              >
                Baixar parques com Informações Gerais confirmadas &nbsp;
                <i class="fa fa-refresh fa-spin" v-if="waitingConfirmedDownload"></i>
              </button>
            </div>
          </div>
        </section>
      </div>
  </Adminlte>
</template>

<script>
  import Adminlte from '@/components/template/Adminlte'
  import ParksFilter from './ParksFilter'
  import { BackendApi } from '@/services/backend_api'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ExportParks',
    components: { Adminlte, ParksFilter },
    data: function () {
      return {
        parks: [],
        waitingDownload: false,
        waitingConfirmedDownload: false
      }
    },
    async mounted () {
      this.parks = await this.getParks()
    },
    methods: {
      async getParks () {
        const response = await BackendApi.getAnonymousClient().get('/parks?hideLogo=true&orderBy=name&limit=0')
        const parksResponseWithNoLinksNeitherTotalElements = Object.values(response.data).slice(0, -2)
        return parksResponseWithNoLinksNeitherTotalElements.map((park) =>
          Object.assign({ isSelected: true }, park)
        )
      },
      handleDownloadClick (e) {
        e.preventDefault()

        const queryParams = {
          parks: this.selectedParksIds.join(',')
        }

        this.waitingDownload = true
        BackendApi.getClient().get('/spreadsheet/parks', {
          params: queryParams, responseType: 'blob'
        }).then((response) => {
          saveAs(response.data, 'parks.xlsx')
        }).finally(() => {
          this.waitingDownload = false
        })
      },
      handleConfirmedDownloadClick (e) {
        e.preventDefault()

        this.waitingConfirmedDownload = true
        BackendApi.getClient().get('spreadsheet/parks/confirmed', {
          responseType: 'blob'
        }).then((response) => {
          saveAs(response.data, 'confirmed-parks.xlsx')
        }).finally(() => {
          this.waitingConfirmedDownload = false
        })
      }
    },
    computed: {
      selectedParksIds: function () {
        return this.parks.filter((park) => park.isSelected).map((park) => park.id)
      }
    }
  }
</script>

<style scoped>
  .inner-box {
    background-color: #488ab3;
    box-shadow: 0px 1px 5px #888888;
    padding: 10px;
    margin-bottom: 15px;
    color: white;
  }
  .confirmed-export-btn {
    margin-top: 10px;
  }
  .help-text {
    margin-top: 8px;
    font-size: 12px;
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// ExportParks.vue?1d45f1f6